import { CommonClassNames } from '@dtvgo/classnames';

var ScrubbingDirection = {
  BACKWARD: 'backward',
  FORWARD: 'forward'
};
var ScrubbingSpeed = {
  x1: 1,
  x2: 2,
  x3: 3
};
var Key = {
  ARROW_LEFT: 'ArrowLeft',
  ARROW_RIGHT: 'ArrowRight',
  ENTER: 'Enter',
  ESCAPE: 'Escape'
};
var ProgressBarClassNames = CommonClassNames.component('progress-bar');
var COLOR_BLUE = '#009fdb';
var DEFAULT_SCRUBBING = {
  direction: undefined,
  speed: undefined
};
var SECONDS_TO_SCRUB = 10;
var SECONDS_TO_SCRUB_MAX_SPEED = 20;
var SCRUB_BASE_TIME = 2;
var SCRUBBING_MAX_SPEED = ScrubbingSpeed.x3;
var noop = function noop() {};
var defaultOnKeyDown = function defaultOnKeyDown(event) {
  return Object.values(Key).includes(event.key) ? event.key : false;
};
var isLeftArrowKey = function isLeftArrowKey(key) {
  return key === Key.ARROW_LEFT;
};
var isRightArrowKey = function isRightArrowKey(key) {
  return key === Key.ARROW_RIGHT;
};
var isEnterKey = function isEnterKey(key) {
  return key === Key.ENTER;
};
var isEscapeKey = function isEscapeKey(key) {
  return key === Key.ESCAPE;
};
var isValidScrubbing = function isValidScrubbing(scrubbing) {
  return Object.values(ScrubbingDirection).includes(scrubbing === null || scrubbing === void 0 ? void 0 : scrubbing.direction) && Object.values(ScrubbingSpeed).includes(scrubbing === null || scrubbing === void 0 ? void 0 : scrubbing.speed);
};
var nextSpeed = function nextSpeed(currentSpeed) {
  return currentSpeed % SCRUBBING_MAX_SPEED + 1;
};

export { COLOR_BLUE, DEFAULT_SCRUBBING, Key, ProgressBarClassNames, SCRUBBING_MAX_SPEED, SCRUB_BASE_TIME, SECONDS_TO_SCRUB, SECONDS_TO_SCRUB_MAX_SPEED, ScrubbingDirection, ScrubbingSpeed, defaultOnKeyDown, isEnterKey, isEscapeKey, isLeftArrowKey, isRightArrowKey, isValidScrubbing, nextSpeed, noop };
//# sourceMappingURL=utils.js.map
